export const getBrowserTimezone = () =>
  Intl.DateTimeFormat().resolvedOptions().timeZone || "UTC";

export const normalizeTimeEntry = (entry) => {
  if (entry && typeof entry === "object" && entry.hour != null) {
    return {
      hour: Number(entry.hour),
      minute: Number(entry.minute || 0),
    };
  }

  const date = new Date(entry);
  if (Number.isNaN(date.getTime())) {
    return { hour: 9, minute: 0 };
  }

  return {
    hour: date.getHours(),
    minute: date.getMinutes(),
  };
};

export const normalizeReportTimes = (times) => {
  const list = Array.isArray(times) ? times : [times];
  return list.map(normalizeTimeEntry);
};

export const getDefaultReportTimes = () => {
  const now = new Date();
  return [{ hour: now.getHours(), minute: now.getMinutes() }];
};

export const withReportTimes = (reportFrequency, times) => ({
  ...reportFrequency,
  timezone: reportFrequency?.timezone || getBrowserTimezone(),
  times: normalizeReportTimes(times),
});

export const hhmmFromTimeEntry = (entry) => {
  const { hour, minute } = normalizeTimeEntry(entry);
  return `${String(hour).padStart(2, "0")}:${String(minute).padStart(2, "0")}`;
};

export const updateTimeEntryAtIndex = (times, index, hhmmValue) => {
  const [hour, minute] = hhmmValue.split(":").map((value) => parseInt(value, 10));
  return normalizeReportTimes(times).map((item, i) =>
    i === index ? { hour, minute } : item
  );
};

export const toPickerTimestamp = (entry) => {
  const { hour, minute } = normalizeTimeEntry(entry);
  const date = new Date();
  date.setHours(hour, minute, 0, 0);
  return date.getTime();
};
